import * as z from "zod";
import { userFacingError } from "../authorization";
import { zql } from "../generatedDrizzleSchema";
import { mutator } from "./mutator";
import { applyToolResult } from "./provideToolResultShared";

export const provideSpaceChatToolResultSchema = z.object({
  chatId: z.string(),
  entryId: z.string(),
  // TOOL_CALL_OUTPUT_V1_BACKCOMPAT start
  output: z.any().optional(),
  outputId: z.string().optional(),
  // TOOL_CALL_OUTPUT_V1_BACKCOMPAT end
  isError: z.boolean().optional(),
  branchId: z.string(),
  pauseAfter: z.boolean().optional(),
  chatModel: z.string().optional(),
});

export const provideSpaceChatToolResult = mutator({
  schema: provideSpaceChatToolResultSchema,
  resolve: {
    branch: { kind: "branch", from: "branchId" },
  },
  permissions: [
    {
      permission: "space:write",
      scopeId: ({ args }) => args.branch.workflow.spaceId,
    },
  ],
  fn: async ({ tx, args }) => {
    const { chatId, branch, pauseAfter } = args;
    const [chat] = await tx.run(
      zql.chats
        .where("id", chatId)
        .related("commit", (c) => c.where("branchId", branch.id))
    );
    if (!chat?.commit) throw userFacingError("Chat not found on branch");

    await applyToolResult(tx, args);

    await tx.mutate.chats.update({
      id: chatId,
      respondingAt: pauseAfter ? null : Date.now(),
      awaitingAction: false,
    });
  },
});
